import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { BehaviorSubject, Observable, map, of } from 'rxjs';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { navigationItems } from '../utils/navigations';
import { Service_RolesArray } from '../utils/role';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  navBarItems: any = [];
  sideNavArray = [];

  private isLoggedInSubject = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.isLoggedInSubject.asObservable();
  
  constructor(public http: HttpService, public storage: StorageService, private router: Router) { }

  apiBaseUrl = environment.apiBaseUrl;

  getOTP(data: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/resend-otp`, data);
  }

  login(data: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/verify-contractor-otp`, data).pipe(
      map((resp: any) => {
        this.isLoggedInSubject.next(true);
        this.storage.setItem('local', 'authData', resp.data);
        this.generateSideNav();
        return resp;    
      })
    );
  }

  logout() {
    return this.http.get(`${this.apiBaseUrl}/logout`).pipe(
      map((resp: any) => {
        this.isLoggedInSubject.next(false);
        this.storage.removeItem('local', 'authData');
        this.storage.removeItem('local', 'appConfig');
      })
    );
  }

  /** Store Front Banners: ROWNER + supermart store type only. */
  shouldShowStoreFrontBanners(data: any): boolean {
    if (!data) return false;
    const storeType = String(data.store_type ?? '').toLowerCase();
    return (
      data.sub_type === 'ROWNER' &&
      (storeType === 'suppermart' || storeType === 'supermart')
    );
  }

  private isStoreFrontBannersNav(navs: { routerLink?: string; id?: number }): boolean {
    return navs.routerLink === '/store-front-banners' || navs.id === 18;
  }

  generateSideNav() {
    this.navBarItems = [];
    this.storage.getItem('local', 'authData').subscribe((data: any) => {
      if(data){
        if(Service_RolesArray.includes(data.sub_type)){
          navigationItems.map((navs: any) => {
            if(navs.roles.includes(data.sub_type)){
              if (this.isStoreFrontBannersNav(navs) && !this.shouldShowStoreFrontBanners(data)) {
                return;
              }
              this.navBarItems.push(navs)
            }
          })
          this.navBarItems.sort((a: any, b: any) => {
            return a.id - b.id;
          });
        }
      }
    })
  }

  getSideBar(): Observable<any>{
    this.navBarItems = new Set(this.navBarItems);
    return of(this.navBarItems);
  }

}




